import ApiService from 'global/utils/ApiService';
import endpointUrls from 'global/Constants/endpointUrls';
import { setAllCitiesWithoutSearch } from 'redux/reducer/basicData/cityReducer';
import { AppDispatch } from 'redux/store';

export const getAllCitiesWithoutSearch = () => async (dispatch: AppDispatch) => {
  await ApiService.post(endpointUrls.cityGetAllPublic, {})
    .then((res: any) => {
      res.isSuccess && dispatch(setAllCitiesWithoutSearch(res.data));
    })
    .catch(() => {});
};
